// Configuration for the frontend-tickets application

// Infer sensible defaults based on current host
const host = typeof window !== 'undefined' ? window.location.hostname : ''
const isDevDomain = /dev\.pianomeetups\.com/i.test(host)
const DEFAULT_API_BASE = isDevDomain ? 'https://dev.pianomeetups.com:8000' : 'http://localhost:8000'
const DEFAULT_GRAPHQL_URL = isDevDomain ? 'https://dev.pianomeetups.com:8000/graphql' : 'http://localhost:8000/graphql'

const config = {
  // API Base URL
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE,
  
  // GraphQL URL
  GRAPHQL_URL: import.meta.env.VITE_GRAPHQL_URL || DEFAULT_GRAPHQL_URL,
  
  // Specific API endpoints
  EVENTS_API: import.meta.env.VITE_EVENTS_API || `${DEFAULT_API_BASE}/events`,
  TICKETS_API: import.meta.env.VITE_TICKETS_API || `${DEFAULT_API_BASE}/tickets`,
  PAYMENTS_API: import.meta.env.VITE_PAYMENTS_API || `${DEFAULT_API_BASE}/payments`,

  // Payment settings
  PAYMENT: {
    REDSYS_MERCHANT_CODE: import.meta.env.VITE_REDSYS_MERCHANT_CODE || '',
    REDSYS_TERMINAL: import.meta.env.VITE_REDSYS_TERMINAL || '1',
    REDSYS_CURRENCY: '978', // EUR
    REDSYS_TRANSACTION_TYPE: '0', // Authorization
    REDSYS_URL: import.meta.env.VITE_REDSYS_URL || 'https://sis-t.redsys.es:25443/sis/realizarPago',
  },

  // Email verification settings
  EMAIL_VERIFICATION: {
    CODE_EXPIRY_MINUTES: 15,
    RESEND_DELAY_SECONDS: 60,
  },


  // Ticket settings
  TICKETS: {
    MAX_TICKETS_PER_ORDER: 10,
    EARLY_BIRD_DAYS: 3, // Days before event for early bird pricing
  },

  // App settings
  APP: {
    NAME: 'PianoMeetups Tickets',
    VERSION: '1.0.0',
    SUPPORT_EMAIL: 'info@pianomeetups.com',
  },
}

export default config
